export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-share-87d5251db5cc13ab6dbc0814ea6a6e47.svg";